module.exports = __webpack_public_path__ + "static/img/logreg.252f28c.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/logreg.svg
// module id = 3FiE
// module chunks = 4